const { startAction, stopAction } = require('./extractStartStopEvents/extractEventAction');
const extractName = require('./extractName');
const createEvent = require('./extractStartStopEvents/createEvent');
const negotiateMergeOrInsertEvents = require('./extractStartStopEvents/negotiateMergeOrInsertEvents');

module.exports = function extractStartStopEvents(dto, events) {
    const despatchPartyName = extractName(dto.DespatchParty);
    const startEvent = createEvent(dto.Atd, dto.Etd, dto.ProofOfDeparture, dto.DepartureLocation, despatchPartyName, startAction);

    const deliveryPartyName = extractName(dto.DeliveryParty);
    const stopEvent = createEvent(dto.Ata, dto.Eta, dto.ProofOfDelivery, dto.ArrivalLocation, deliveryPartyName, stopAction);

    negotiateMergeOrInsertEvents(startEvent, events, 0);
    negotiateMergeOrInsertEvents(stopEvent, events, events.length);

    return events;
}
